import { Product } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Placeholder, ProductCard } from '@components';
import { INITIAL_CATEGORY_STATE } from '@hooks/category/category.hook';
import { Alert, Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { t } from '@translations';

// STYLES
//--------

const ProductListGrid = styled(Box)`
  display: grid;
  gap: 20px;
  ${breakpoints.up('lg')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  ${breakpoints.up('xl')} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  ${breakpoints.down('lg')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
`;

// TYPES
//-------

export type ProductListProps = {
  isWorking?: boolean;
  productItems?: Product[];
};

// COMPONENTS
//------------
export const ProductList = ({ productItems, isWorking }: ProductListProps) => {
  if (isWorking) {
    return <ProductListPlaceholder />;
  }
  if (!productItems || productItems.length === 0) {
    return <Alert severity='info'>{t(TextCodes.Product.Search.NoResults)}</Alert>;
  }
  return (
    <ProductListGrid>
      {productItems.map((product) => (
        <ProductCard key={product.code} {...product} />
      ))}
    </ProductListGrid>
  );
};

export const ProductListPlaceholder = () => {
  return (
    <div className='product-list'>
      <ProductListGrid>
        <Placeholder
          numberOfItems={INITIAL_CATEGORY_STATE.itemPerPage}
          component={<ProductCard isLoading={true} />}
        />
      </ProductListGrid>
    </div>
  );
};
